import App from "./App.jsx";

export default App;
